/* Gear specifications reuse the exact image pixels currently shown in the gallery. */
(() => {
  function boot() {
    document.querySelectorAll('[data-nspire-catalog="gear"]').forEach(root => {
      if (root.dataset.gearStoryReady) return;
      root.dataset.gearStoryReady = 'true';
      const sync = () => {
        if (root.dataset.currency === 'EUR') {
          document.querySelectorAll('#ea-sticky-cart-root .easc-priceDiv .actualPrice, #ea-sticky-cart-root .easc-priceDiv .easc-comparePrice').forEach(price => {
            const match = price.textContent.trim().match(/^(?:€\s*)?([\d.\s]+(?:,\d{2})?)(?:\s*EUR)?$/);
            if (!match) return;
            const text = '€ ' + match[1].trim().replace(/,00$/, '');
            if (price.textContent !== text) price.textContent = text;
          });
        }
        root.querySelectorAll('[data-gear-source-image]').forEach(card => {
          const id = card.getAttribute('data-gear-source-image');
          const image = card.querySelector('img');
          if (!image) return;
          const source = root.querySelector('[data-catalog-photo][data-image-id="' + CSS.escape(id) + '"] img');
          if (!source) return;
          ['src', 'srcset'].forEach(name => {
            const value = source.getAttribute(name);
            if (value && image.getAttribute(name) !== value) image.setAttribute(name, value);
            else if (!value && image.hasAttribute(name)) image.removeAttribute(name);
          });
        });
      };
      sync();
      new MutationObserver(sync).observe(root, {childList:true,subtree:true});
      new MutationObserver(sync).observe(document.body, {childList:true,subtree:true,characterData:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
